const InfoIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" width="100" height="100">
        <path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z" fill="currentColor"/>
        <path d="M14,19H12V12H10V10h2a2,2,0,0,1,2,2Z" fill="currentColor"/>
        <circle cx="12" cy="6.5" r="1.5" fill="currentColor"/>
    </svg>
);
export default InfoIcon;
